import { Component, OnInit } from '@angular/core';
import { UnifiedCartService } from '../../services/unified-cart/unified-cart.service';
import { ActivatedRoute } from '@angular/router';
import {
  CartItemModel,
  CourseTimeModel
} from '../../core/models';
import {
  CartService
} from '../../services/cart/cart.service';
import {
  InvoiceDownloadModel,
  InvoiceService
} from '../../services/invoice/invoice.service';
import {
  AuthSessionService
} from '../../services/auth-session/auth-session.service';
import {
  OrderService
} from 'src/app/services/order/order.service';
import { CourseService } from 'src/app/services/course/course.service';

export interface ShortCourseConfirmationModel {
  orderId: number;
  studentEmail: string;
  totalAmount: number;
  currencyCode: string;
  courseName: string;
  courseCode: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  jobNo?: string;

  duration: string;
}

@Component({
  selector: 'app-booking-confirmation',
  templateUrl: './booking-confirmation.component.html',
  styleUrls: ['./booking-confirmation.component.scss']
})
export class BookingConfirmationComponent implements OnInit {

  unifiedCartResult: { status: string; orderNo: string; amount: number; currency: string } | null = null;
  isUnifiedCartReturn = false;
  bookingReference = '';

  bookingNewReference = '';

  items: CartItemModel[] = [];

  selectedCourseTimes: {
    [courseId: number]: CourseTimeModel
  } = {};

  student: any = {};

  invoice: InvoiceDownloadModel | null = null;

  paymentStatus = 'Paid';

  paymentType = '';

  orderId = 0;

  shortCourseDetails:
    ShortCourseConfirmationModel | null = null;

  isCompletingOrder = false;

  completionError = '';
  //store   prefix
  ReferencePrefix: string = '';

  //long store   prefix
  LongOrderReferencePrefix: string = '';
  constructor(
    private route: ActivatedRoute,
    private cartService: CartService, private unifiedCart: UnifiedCartService,
    private invoiceService: InvoiceService,
    public session: AuthSessionService,
    private orderService: OrderService, private courseService: CourseService
  ) {
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('unified_cart') === '1') {
      this.isUnifiedCartReturn = true;
      const sessionId = this.route.snapshot.queryParamMap.get('session_id');
      if (!sessionId) { this.completionError = 'Missing Stripe checkout session.'; return; }
      this.isCompletingOrder = true;
      this.unifiedCart.checkoutResult(sessionId).subscribe({
        next: result => {
          this.isCompletingOrder = false;
          this.unifiedCartResult = result;
          this.paymentStatus = result.status;
          this.bookingNewReference = result.orderNo;
          if (result.status.toLowerCase() === 'paid') this.unifiedCart.clear();
        },
        error: () => { this.isCompletingOrder = false;
          this.completionError = 'Unable to verify your payment. Please contact ECB Training with your Stripe confirmation.'; }
      });
      return;
    }
    this.paymentType = (this.route.snapshot.queryParamMap.get('type') || '').toUpperCase();

    if (this.paymentType === 'REGULAR') {
      this.getShortOrderReferencePrefix();
      return;
    }
    else if (this.paymentType === 'VOC') {
      this.loadVOCShortCourseData();
      return;
    } else {
      this.loadPageData();

    }
  }


  //get prefix
  getShortOrderReferencePrefix(): void {

    this.courseService
      .GetReferencePrefix('SHORT_COURSE_ORDER')
      .subscribe({
        next: (prefix: string) => {

          this.ReferencePrefix = prefix;
          this.loadRegularShortCourseData();
        },
        error: (error) => {

          console.error(
            'Error loading reference prefix',
            error
          );

        }
      });
  }






  loadRegularShortCourseData(): void {
    this.loadShortCourseConfirmation('REGULAR');
  }

  loadVOCShortCourseData(): void {
    this.loadShortCourseConfirmation('VOC');
  }

  private loadShortCourseConfirmation(
    type: 'REGULAR' | 'VOC'
  ): void {
    const raw =
      sessionStorage.getItem('ecb_pending_booking');

    if (!raw) {
      this.completionError =
        'Booking information could not be found.';

      return;
    }

    try {
      const pending = JSON.parse(raw);

      this.orderId =
        Number(
          pending.OrderId ??
          pending.orderId ??
          0
        );

      this.shortCourseDetails = {
        orderId: this.orderId,

        studentEmail:
          pending.studentEmail ?? '',

        totalAmount:
          Number(pending.totalAmount ?? 0),

        currencyCode:
          pending.currencyCode ?? 'AUD',

        courseName:
          pending.courseName ??
          (
            type === 'VOC'
              ? 'Verification of Competency'
              : 'Short Course'
          ),

        courseCode:
          pending.courseCode ?? '',

        startDate:
          pending.startDate ?? '',

        startTime:
          pending.startTime ?? '',

        endDate:
          pending.endDate ?? '',

        endTime:
          pending.endTime ?? '',

        jobNo:
          pending.jobNo ??
          pending.JobNumber ??
          '',
        duration: pending.duration ?? ''
      };


      this.bookingNewReference =
        this.orderId > 0
          ? `#${this.ReferencePrefix}${String(this.orderId)}`
          : this.createReference();

      this.paymentStatus =
        this.route.snapshot.queryParamMap.get(
          'session_id'
        )
          ? 'Paid'
          : 'Booked';

      if (
        this.paymentStatus === 'Paid' &&
        this.orderId > 0
      ) {
        this.completeShortCourseOrder(type);
      }

      sessionStorage.removeItem(
        'ecb_pending_booking'
      ); 
    } catch (error) {
      console.error(
        'Invalid pending booking details:',
        error
      );

      this.completionError =
        'Booking information could not be loaded.';

      sessionStorage.removeItem(
        'ecb_pending_booking'
      );
    }
  }

  private completeShortCourseOrder(type: 'REGULAR' | 'VOC'): void {
    this.isCompletingOrder = true;
    this.completionError = '';

    this.orderService.shortCourseOrderComplete(this.orderId, type, this.shortCourseDetails)
      .subscribe({
        next: () => {
          this.isCompletingOrder = false;
        },
        error: error => {
          this.isCompletingOrder = false;

          console.error(
            'Unable to complete short-course order:',
            error
          );

          this.completionError =
            'Your payment was successful, but the booking status could not be refreshed.';
        }
      });
  }

  get isRegularPayment(): boolean {
    return this.paymentType === 'REGULAR';
  }

  get isVOCPayment(): boolean {
    return this.paymentType === 'VOC';
  }

  get confirmationTitle(): string {
    return this.isVOCPayment
      ? 'Your VOC payment is confirmed!'
      : 'Your short course booking is confirmed!';
  }

  get courseDateRange(): string {
    if (!this.shortCourseDetails) {
      return '-';
    }

    const start =
      this.shortCourseDetails.startDate;

    const end =
      this.shortCourseDetails.endDate;

    if (!start && !end) {
      return '-';
    }

    if (!end || start === end) {
      return start;
    }

    return `${start} - ${end}`;
  }

  get courseTimeRange(): string {
    if (!this.shortCourseDetails) {
      return '-';
    }

    const start =
      this.shortCourseDetails.startTime;

    const end =
      this.shortCourseDetails.endTime;

    if (!start && !end) {
      return '-';
    }

    if (!end) {
      return start;
    }

    return `${start} - ${end}`;
  }

  loadPageData(): void {
     
    const raw =
      sessionStorage.getItem(
        'ecb_pending_booking'
      );

    if (raw) {
      const pending = JSON.parse(raw);

      this.items = pending.items || [];
      this.student = pending.student || {};

      this.selectedCourseTimes =
        pending.selectedCourseTimes || {};

      this.bookingReference =
        pending.reference ||
        this.createReference();

      this.paymentStatus =
        this.route.snapshot.queryParamMap.get(
          'session_id'
        )
          ? 'Paid'
          : 'Booked';

      this.invoice = this.buildInvoice();

      this.cartService.clear();

      sessionStorage.removeItem(
        'ecb_pending_booking'
      );  

      this.orderService
        .OrderComplete(this.bookingReference)
        .subscribe({
          next: (response) => {

            const orderNo = response?.[0]?.orderNo;

            console.log('Order No:', orderNo);
            this.bookingNewReference = orderNo;

          },
          error: error => {
            console.error(error);
          }
        });

      return;
    }

    this.items =
      this.cartService.getItems();

    this.bookingReference =
      this.createReference();

    this.invoice =
      this.buildInvoice();

    if (this.items.length) {
      this.cartService.clear();
    }

    this.orderService
      .OrderComplete(this.bookingReference)
      .subscribe({
        next: (response) => {

          const orderNo = response?.[0]?.orderNo;
 
          this.bookingNewReference = orderNo;
        },
        error: error => {
          console.error(error);
        }
      });
  }

  getSelectedTime(
    courseId: number
  ): CourseTimeModel | null {
    return (
      this.selectedCourseTimes[courseId] ||
      null
    );
  }

  get subtotal(): number {
    return this.items.reduce(
      (total, item) =>
        total +
        Number(item.course.price || 0),
      0
    );
  }

  get gst(): number {
    return this.subtotal * 0.10;
  }

  get total(): number {
    return this.subtotal + this.gst;
  }

  downloadInvoice(): void {

    if (!this.invoice) {
      this.invoice = this.buildInvoice();
    }

    this.invoiceService.downloadInvoice(
      this.invoice
    );
  }

  private buildInvoice():
    InvoiceDownloadModel {
    const invoiceItems =
      this.invoiceService
        .buildItemsFromCart(
          this.items,
          null
        )
        .map(item => {
          const selected =
            this.selectedCourseTimes[
            item.courseId
            ];

          return {
            ...item,
            courseTimeId:
              selected?.courseTimeId || 0,
            dateRange:
              selected?.dateRange || '',
            time:
              selected?.time || '',
            locationName:
              selected?.locationName || '',
            deliveryMode:
              selected?.deliveryMode || ''
          };
        });

    const subtotal =
      invoiceItems.reduce(
        (total, item) =>
          total +
          Number(item.lineAmount || 0),
        0
      );

    const first = invoiceItems[0];

    return {
      reference:
        this.bookingNewReference,

      customerName:
        `${this.student.firstName || ''} ${this.student.lastName || ''}`
          .trim() ||
        this.session
          .getCurrentUser()
          ?.fullName ||
        'Customer',

      customerEmail:
        this.student.email ||
        this.session
          .getCurrentUser()
          ?.email ||
        '',

      customerPhone:
        this.student.mobileNo || '',

      paymentStatus:
        this.paymentStatus,

      invoiceDate:
        new Date().toISOString(),

      items:
        invoiceItems,

      subtotal,

      gst:
        subtotal * 0.10,

      total:
        subtotal * 1.10,

      currencyCode:
        'AUD',

      dateRange:
        first?.dateRange || '',

      time:
        first?.time || '',

      locationName:
        first?.locationName || '',

      deliveryMode:
        first?.deliveryMode || ''
    };
  }

  private createReference(): string {
    return `ECB-${new Date().getFullYear()}-${String(
      Math.floor(
        Math.random() * 90000
      ) + 10000
    )}`;
  }
}